<template>
  <layout
    title="Ask a Question"
    :logo="logo"
    class="contact-us-page"
  >

    <contact-form />

    <template v-slot:footer>
      <page-footer footerText="Powered by" @click.native="handleFooterClick()" />
    </template>
  </layout>
</template>

<script>
import Layout from "@/components/layout/Layout.vue";
import PageFooter from "@/components/layout/PageFooter.vue";
import router from "../router/index";
import ContactForm from "@/components/ContactForm.vue";

export default {
  name: "ContactUs",
  components: {
    Layout,
    PageFooter,
    ContactForm,
  },
  methods: {
    handleFooterClick() {
      router.push("/");
    },
  },
  computed: {
    pageTitle() {
      let title = "Thank you for your interest";
      if (this.settings.property_name) {
        title += " in " + this.settings.property_name;
      }
      return title;
    },
    logo() {
      return this.$store.state.settings.interface?.logo ? this.$store.state.settings.interface.logo : '/images/bot-icon.svg';
    },
  },
  inject: ["settings"],
};
</script>